import React from 'react'
import { deleteProfile } from '../../../../services/operation/profileApi'
import { Navigate, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import {FiTrash2} from "react-icons/fi"
import { logout } from '../../../../services/operation/authApi';
export default function DeleteAccount (){
 
    const navigate=useNavigate();
    const dispatch=useDispatch();
    const{token}=useSelector((state)=>state.auth)

    const  handleDelete=()=>{
          try{
              deleteProfile(token);
              dispatch(logout(navigate));
              navigate("/");
          } catch(error){
            console.log("error is handle delete",error);
          }
    }
  return (
    <>
    <div  className="my-10 flex flex-row gap-x-5 rounded-md border-[1px] border-pink-700 bg-pink-900 p-8 px-12 mb-4">
        <div className="flex aspect-square h-14 w-14 items-center justify-center rounded-full bg-pink-700">
             <FiTrash2 className="text-3xl text-pink-200"/>
             </div>
             <div className="flex flex-col space-y-2">
                 <h2 className="text-lg font-semibold text-richblack-5">Delete Account</h2>
                 <div className="w-3/5 text-pink-25">
                         
                 <p>Would you like to delete account ?</p>
                  <p>This account may contain Paid Courses. Deleting your account is permanent and will remove all the contain associated with it.</p>
                  <p className=' mt-3'>"Once Deleted Can't Be Recovered</p>
                 </div>
        
                 <button
                  className="w-fit cursor-pointer italic text-pink-300"
                 onClick={handleDelete}>
                      <p>I want to delete my account.</p>
                 </button>
             </div>
        </div>
    
    </>
  )
}

